import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function passwordStrengthValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    const errors: ValidationErrors = {};


    const hasUppercase = /[A-Z]/.test(value);
    const hasLowercase = /[a-z]/.test(value);
    const hasLetters = hasUppercase || hasLowercase;
    const hasNumber = /\d/.test(value);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(value);

    if (!hasUppercase) {
      errors["noUppercase"] = true;
    }
    if (!hasLowercase) {
      errors["noLowercase"] = true;
    }
    if (!hasLetters || !hasNumber) {
      errors["noLettersOrNumbers"] = true;
    }
    if (!hasSpecialChar) {
      errors["noSpecialChar"] = true;
    }
    
    return Object.keys(errors).length ? errors : null;
  };
}
